export default "__VITE_ASSET__BWxvt1kl__"